import { asyncLoadRouter } from '@router/helper'

const analytics = [
  {
    path: 'analytics',
    component: asyncLoadRouter('machines/Analytics'),
    meta: {
      breadcrumb: (i18n) => [
        {
          text: i18n.t('machine.analytics.title'),
          to: { name: 'machines-analytics' },
        },
      ],
    },
    children: [
      {
        path: '',
        name: 'machines-analytics',
        component: asyncLoadRouter('machines/analytics/Show'),
        meta: { breadcrumb: (i18n) => [{ text: i18n.t('shared.actions.show') }] },
      },
    ],
  },
]

export default analytics
